(function () {
  'use strict';
  if (window.DaLucaNativeCartAdapter) return;

  const excluded = '#Product-Drawer,#Product-Drawer-Content,product-add-to-cart-sticky,product-form[data-sticky],.daluca-pdp-upsell,.daluca-care-proxy-v35,[data-daluca-care-proxy],[data-daluca-accessory-addon-group],[data-daluca-accessory-addon-row],.daluca-ready-addon-row,.daluca-strap-upgrade,[data-daluca-quick-release]';
  const controlsSelector = 'input:not([type="hidden"]):not([type="submit"]):not([type="button"]),select,textarea';
  const clean = value => String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
  const propertyName = value => String(value || '').match(/^properties\[([^\]]+)\](?:\[\])?$/)?.[1] || '';
  const fieldKey = value => clean(propertyName(value) || value).replace(/\s*\*\s*$/, '').toLocaleLowerCase();
  const valueKey = value => clean(value).replace(/\s*\(\s*\+\s*(?:[A-Z]{2,3}\s*)?[$€£¥]?\s*[\d,]+(?:\.\d{1,2})?(?:\s*[A-Z]{2,3})?\s*\)\s*$/i, '').replace(/\s+\+\s*(?:[A-Z]{2,3}\s*)?[$€£¥]\s*[\d,]+(?:\.\d{1,2})?(?:\s*[A-Z]{2,3})?\s*$/i, '').trim().toLocaleLowerCase();
  const delay = milliseconds => new Promise(resolve => setTimeout(resolve, milliseconds));

  function getRoot() {
    const roots = Array.from(document.querySelectorAll('.thb-product-detail[data-daluca-main-product-id],.thb-product-detail'));
    return roots.find(root => !root.closest(excluded) && root.closest('main')) || roots.find(root => !root.closest(excluded)) || null;
  }

  function owned(element, root) {
    return !!element && !!root && root.contains(element) && !element.closest(excluded) && element.closest('.thb-product-detail') === root;
  }

  function getForm() {
    const root = getRoot();
    if (!root) return null;
    const forms = Array.from(root.querySelectorAll('form[action*="/cart/add"],form[data-type="add-to-cart-form"]')).filter(form => owned(form, root));
    const productId = String(root.dataset.dalucaMainProductId || '');
    return forms.find(form => productId && String(form.querySelector('[name="product-id"]')?.value || '') === productId)
      || forms.find(form => form.closest('.daluca-accessory-order-step--purchase'))
      || forms.find(form => form.matches('form[data-type="add-to-cart-form"]') && form.closest('product-form:not([data-sticky])'))
      || forms.find(form => form.id.startsWith('product-form-') && form.querySelector('[name="id"]'))
      || (forms.length === 1 ? forms[0] : null);
  }

  function labelFor(control, root) {
    const direct = control.id ? root.querySelector('label[for="' + CSS.escape(control.id) + '"]') : null;
    return direct || control.closest('label');
  }

  function choiceText(control, root) {
    if (control.tagName === 'OPTION') return clean(window.DaLucaI18n.sourceText(control) || control.value);
    const label = labelFor(control, root);
    const choice = control.closest('label,.gpo-swatches,.gpo-ov-item,[role="radio"],[role="option"]');
    const title = choice?.querySelector('.gpo-swatch__title,.gpo-ov-item-title,.gpo-ov-title');
    return clean(window.DaLucaI18n.chainText(() => (title), [{kind:"text", optional:true}]) || window.DaLucaI18n.chainText(() => (label), [{kind:"text", optional:true}]) || control.value);
  }

  function recordFor(control, root, form) {
    const app = control.closest('.gpo-app,.gpo-container');
    const explicit = control.closest('.gpo-element,[data-gpo-element]');
    let container = explicit;
    let label = explicit?.querySelector('.gpo-label .label-content,.gpo-label,legend');
    for (let node = control.parentElement, depth = 0; !label && node && node !== app && node !== form && depth < 7; node = node.parentElement, depth += 1) {
      label = node.querySelector(':scope > .gpo-label .label-content,:scope > .gpo-label,:scope > legend');
      if (label) container = node;
    }
    if (!label && !app) label = labelFor(control, root);
    const dataOwner = control.closest('[data-field-name],[data-name]');
    const property = propertyName(control.name);
    const dataName = clean(control.getAttribute('data-field-name') || control.getAttribute('data-name') || dataOwner?.getAttribute('data-field-name') || dataOwner?.getAttribute('data-name'));
    const labelName = clean(window.DaLucaI18n.chainText(() => (label), [{kind:"text", optional:true}])).replace(/\s*\*\s*$/, '');
    const nativeName = clean(control.name);
    const aliases = Array.from(new Set([property, dataName, labelName, app ? nativeName : ''].map(value => clean(propertyName(value) || value)).filter(value => value && value[0] !== '_')));
    if (!aliases.length || property?.startsWith('_') || nativeName.startsWith('_')) return null;
    const name = property || dataName || labelName || nativeName;
    return {control, container: container || control.closest('.product-form__input') || control.parentElement, app, form, name, aliases};
  }

  function fieldsFor(root, form) {
    if (!root || !form) return [];
    const controls = new Set();
    root.querySelectorAll('.gpo-app,.gpo-container').forEach(app => {
      if (owned(app, root)) app.querySelectorAll(controlsSelector).forEach(control => {
        if (owned(control, root) && (!control.form || control.form === form)) controls.add(control);
      });
    });
    Array.from(form.elements).forEach(control => {
      if (control.matches?.(controlsSelector) && propertyName(control.name) && owned(control, root)) controls.add(control);
    });
    const fields = new Map();
    controls.forEach(control => {
      const record = recordFor(control, root, form);
      if (!record) return;
      const key = fieldKey(record.name);
      if (!fields.has(key)) fields.set(key, {name:record.name, aliases:new Set(), records:[]});
      const field = fields.get(key);
      record.aliases.forEach(alias => field.aliases.add(alias));
      field.records.push(record);
    });
    return Array.from(fields.values());
  }

  function visible(record) {
    const stop = record.app || record.form;
    for (let node = record.container; node; node = node.parentElement) {
      if (node.hidden || node.getAttribute('aria-hidden') === 'true' || node.classList.contains('gpo-hidden')) return false;
      const style = getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      if (node === stop) break;
    }
    return true;
  }

  function activeRecords(field) {
    return field.records.filter(visible);
  }

  function emit(control) {
    control.dispatchEvent(new Event('input', {bubbles:true}));
    control.dispatchEvent(new Event('change', {bubbles:true}));
  }

  function assignValue(control, value) {
    if (control.value === value) return false;
    const descriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(control), 'value');
    if (descriptor?.set) descriptor.set.call(control, value);
    else control.value = value;
    emit(control);
    return true;
  }

  function choicesFor(records, root) {
    return records.flatMap(record => {
      const control = record.control;
      if (control.tagName === 'SELECT') return Array.from(control.options).map(option => ({control, option, value:String(option.value), label:choiceText(option, root), disabled:control.disabled || option.disabled || option.hidden || option.dataset.dalucaBuckleUnavailable === 'true'}));
      if (/^(radio|checkbox)$/.test(control.type)) return [{control, option:null, value:String(control.value), label:choiceText(control, root), disabled:control.disabled || control.dataset.dalucaBuckleUnavailable === 'true'}];
      return [];
    });
  }

  function matchChoice(value, choices) {
    let matches = choices.filter(choice => choice.value === value);
    if (matches.length !== 1) matches = choices.filter(choice => clean(choice.label) === clean(value));
    if (matches.length !== 1) matches = choices.filter(choice => valueKey(choice.value) === valueKey(value) || valueKey(choice.label) === valueKey(value));
    return matches.length === 1 && !matches[0].disabled ? matches[0] : null;
  }

  function selectionFor(value, choices, multiple) {
    const exact = matchChoice(value, choices);
    if (exact) return [exact];
    if (!multiple) return value === '' ? [] : null;
    if (value === '') return [];
    let values;
    try { const parsed = JSON.parse(value); if (Array.isArray(parsed) && parsed.every(entry => typeof entry === 'string')) values = parsed; } catch (_) {}
    if (!values) values = value.split(/,\s*|\r?\n/);
    const selected = values.map(entry => matchChoice(entry, choices));
    return selected.every(Boolean) && new Set(selected).size === selected.length ? selected : null;
  }

  function fieldMatches(field, saved) {
    const keys = new Set(Array.from(field.aliases, fieldKey));
    return saved.filter(entry => keys.has(fieldKey(entry.key)));
  }

  function restoreField(field, value, root, apply) {
    const records = activeRecords(field);
    if (!records.length) return {ok:true, changed:false};
    const choices = choicesFor(records, root);
    if (choices.length) {
      const multiple = records.some(record => record.control.multiple) || records.every(record => record.control.type === 'checkbox');
      const selected = selectionFor(value, choices, multiple);
      if (!selected) return {ok:false, changed:false};
      if (!multiple && !selected.length && value !== '') return {ok:false, changed:false};
      const want = new Set(selected);
      let changed = false;
      const selects = new Map();
      choices.slice().sort((a, b) => Number(want.has(b)) - Number(want.has(a))).forEach(choice => {
        const current = choice.option ? choice.option.selected : choice.control.checked;
        const next = want.has(choice);
        if (current === next) return;
        changed = true;
        if (!apply) return;
        if (choice.option) {
          choice.option.selected = next;
          selects.set(choice.control, true);
        } else if (!choice.control.disabled) {
          if (next || choice.control.type === 'checkbox') choice.control.click();
          else { choice.control.checked = false; emit(choice.control); }
        }
      });
      if (apply) selects.forEach((unused, select) => {
        if (!selected.length) select.selectedIndex = -1;
        emit(select);
      });
      return {ok:apply || !changed, changed};
    }
    const texts = records.map(record => record.control).filter(control => control.tagName === 'TEXTAREA' || !/^(file|hidden|radio|checkbox|button|submit|reset|image)$/.test(control.type));
    if (texts.length !== 1 || texts[0].disabled) return {ok:value === '' && !texts.length, changed:false};
    const text = texts[0];
    if (!apply) return {ok:String(text.value) === value, changed:false};
    return {ok:true, changed:assignValue(text, value)};
  }

  function passiveKeys(form) {
    return new Set(Array.from(form?.querySelectorAll('[data-daluca-qr-property]') || [], input => fieldKey(propertyName(input.name))).filter(Boolean));
  }

  async function restore(savedProperties) {
    const saved = Object.entries(savedProperties || {}).filter(([key, value]) => key && key[0] !== '_' && value != null).map(([key, value]) => ({key, value:String(value)}));
    let root, form, fields = [];
    const recognized = new Set();
    let stable = 0;
    for (let pass = 0; pass < 16; pass += 1) {
      root = getRoot(); form = getForm(); fields = fieldsFor(root, form);
      let changed = false;
      fields.forEach(field => {
        const matches = fieldMatches(field, saved);
        matches.forEach(entry => recognized.add(entry.key));
        if (!activeRecords(field).length) return;
        if (matches.length) {
          if (new Set(matches.map(entry => valueKey(entry.value))).size !== 1) return;
          changed = restoreField(field, matches[0].value, root, true).changed || changed;
        } else {
          const records = activeRecords(field);
          const text = records.length === 1 && records[0].control;
          if (text && !text.required && (text.tagName === 'TEXTAREA' || /^(text|search|email|tel|url)$/.test(text.type))) changed = assignValue(text, '') || changed;
          else if (records.length && records.every(record => record.control.type === 'checkbox' && !record.control.required)) changed = restoreField(field, '', root, true).changed || changed;
        }
      });
      const passive = passiveKeys(form);
      const unknown = saved.some(entry => clean(entry.value) && !recognized.has(entry.key) && !passive.has(fieldKey(entry.key)));
      stable = changed || !form || unknown ? 0 : stable + 1;
      if (stable >= 3) break;
      await delay(160);
    }
    root = getRoot(); form = getForm(); fields = fieldsFor(root, form);
    const missing = new Set();
    const finalRecognized = new Set();
    fields.forEach(field => {
      const matches = fieldMatches(field, saved);
      matches.forEach(entry => finalRecognized.add(entry.key));
      if (!activeRecords(field).length || !matches.length) return;
      if (new Set(matches.map(entry => valueKey(entry.value))).size !== 1 || !restoreField(field, matches[0].value, root, false).ok) matches.forEach(entry => missing.add(entry.key));
    });
    const passive = passiveKeys(form);
    saved.forEach(entry => {
      if (clean(entry.value) && !finalRecognized.has(entry.key) && !passive.has(fieldKey(entry.key))) missing.add(entry.key);
    });
    return {ok:!!form && missing.size === 0, missing:Array.from(missing)};
  }

  function feeFor(choice) {
    const source = choice.option || choice.control;
    const explicit = source.getAttribute('data-addon-price');
    if (explicit !== null) {
      const amount = Number(explicit);
      return {amount:Number.isFinite(amount) && amount >= 0 ? amount : 0, known:explicit.trim() !== '' && Number.isFinite(amount) && amount >= 0};
    }
    const text = choice.label || choice.value;
    const matches = Array.from(text.matchAll(/(?:\(\s*\+\s*(?:[A-Z]{2,3}\s*)?[$€£¥]?\s*|\+\s*(?:[A-Z]{2,3}\s*)?[$€£¥]\s*)([\d,]+(?:\.\d{1,2})?)(?:\s*[A-Z]{2,3})?/gi));
    if (!matches.length) return {amount:0, known:!/[+]\s*(?:[A-Z]{2,3}\s*)?[$€£¥]|[$€£¥]\s*[+]/i.test(text)};
    const amount = Number(matches[0][1].replace(/,/g, ''));
    return {amount:Number.isFinite(amount) ? amount : 0, known:matches.length === 1 && Number.isFinite(amount)};
  }

  function snapshot() {
    const root = getRoot();
    const form = getForm();
    const fields = fieldsFor(root, form);
    const properties = {};
    const managedKeys = new Set();
    let pricingKnown = !!form;
    if (form) {
      new FormData(form).forEach((value, name) => {
        const key = propertyName(name);
        if (!key) return;
        if (typeof value !== 'string') { if (value?.size) pricingKnown = false; return; }
        if (Object.prototype.hasOwnProperty.call(properties, key) && properties[key] !== value) {
          if (key.startsWith('_gpo_')) pricingKnown = false;
          else properties[key] += ', ' + value;
        } else properties[key] = value;
        if (key.startsWith('_gpo_')) managedKeys.add(key);
      });
    }
    let paidAmount = 0;
    const priced = new Set();
    fields.forEach(field => {
      field.aliases.forEach(alias => managedKeys.add(alias));
      const choices = choicesFor(activeRecords(field), root);
      choices.filter(choice => !choice.disabled && (choice.option ? choice.option.selected : choice.control.checked)).forEach(choice => {
        const identity = choice.option || choice.control;
        if (priced.has(identity)) return;
        priced.add(identity);
        const fee = feeFor(choice);
        paidAmount += fee.amount;
        pricingKnown = pricingKnown && fee.known;
      });
    });
    const input = form?.querySelector('[name="id"]');
    return {variantId:String(input?.value || ''), properties, managedKeys:Array.from(managedKeys), paidAmount:Math.round(paidAmount * 100) / 100, pricingKnown, hasGpo:!!root && Array.from(root.querySelectorAll('.gpo-app,.gpo-container')).some(app => owned(app, root))};
  }

  function isReady() {
    const root = getRoot();
    const form = getForm();
    if (!root || !form || !form.querySelector('[name="id"]')?.value) return false;
    const apps = Array.from(root.querySelectorAll('.gpo-app,.gpo-container')).filter(app => owned(app, root));
    return !apps.length || fieldsFor(root, form).length > 0;
  }

  window.DaLucaNativeCartAdapter = {getForm, getRoot, isReady, restore, snapshot, refresh:snapshot};
})();

